var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 18,
  fill: "none",
  viewBox: "0 0 17 18",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.673 8.047v2.973h4.92c-.197 1.277-1.484 3.74-4.92 3.74a5.477 5.477 0 0 1-5.372-5.575 5.477 5.477 0 0 1 5.372-5.373 4.89 4.89 0 0 1 3.46 1.335l2.352-2.27A8.34 8.34 0 0 0 8.673.612a8.674 8.674 0 0 0 0 17.347c4.79 0 8.327-3.517 8.327-8.476 0-.481-.048-.963-.135-1.436z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .612h17V17.96H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google.222842dcd547ca233b66680a3b85beea.svg";